export default __webpack_public_path__ + "static/media/button_deposit.0ac04fa7.svg";